module.exports = __webpack_public_path__ + "svgs/no_doctor_img.72ec7299.svg";